import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaComments,
  FaPhone,
  FaShieldAlt,
} from "react-icons/fa";
import getImageUrl from "../../../utils/imageUrl";
import API from "../../../services/api";

import "./ProviderBanner.css";

export default function ProviderBanner({ provider }) {

  const navigate = useNavigate();

  const [chatLoading, setChatLoading] =
    useState(false);

  const [chatError, setChatError] =
    useState("");


  // ==========================================
  // Provider Check
  // ==========================================

  if (!provider) return null;

  console.log(
  "🔥 PROVIDER BANNER DATA:",
  JSON.stringify(provider, null, 2)
);


  // ==========================================
  // Provider Type
  // ==========================================

  const providerType = (
    provider.providerType ||
    provider.businessType ||
    ""
  )
    .trim()
    .toLowerCase();


  // ==========================================
  // Chat & Book Availability
  // ==========================================

 const chatOrderProviders = [
  "home chef",
  "homechef",
  "home kitchen",
  "homekitchen",
  "bakery",
  "catering",
  "provision",
  "provision store",
];

  const comingSoonProviders = [
    "restaurant",
    "hotel",
  ];


  const canChatAndBook =
    chatOrderProviders.includes(
      providerType
    );


  const isChatComingSoon =
    comingSoonProviders.includes(
      providerType
    );


  // ==========================================
  // Images
  // ==========================================

  

const bannerPhoto =
  provider.photos?.businessPhoto ||
  provider.photos?.profilePhoto;

const logoPhoto =
  provider.photos?.businessLogo ||
  provider.photos?.profilePhoto;

const bannerImage = bannerPhoto
  ? getImageUrl(`/uploads/provider/${bannerPhoto}`)
  : "/images/default-business.jpg";

const logoImage = logoPhoto
  ? getImageUrl(`/uploads/provider/${logoPhoto}`)
  : "/images/default-logo.png";
  // ==========================================
  // Chat & Book Order
  // ==========================================

  const handleChatAndBook =
    async () => {

      if (chatLoading) {
        return;
      }

      setChatError("");


      // ----------------------------------------
      // Provider ID
      // ----------------------------------------

      const providerId =
        provider._id ||
        provider.id;


      if (!providerId) {

        console.error(
          "Provider ID is missing"
        );

        setChatError(
          "Unable to start conversation."
        );

        return;
      }


      // ----------------------------------------
      // Login Check
      // ----------------------------------------

      const token =
        localStorage.getItem("token");


      if (!token) {

        navigate(
          `/login?redirect=/provider/${providerId}`
        );

        return;
      }


      try {

        setChatLoading(true);


        // --------------------------------------
        // Create / Get Conversation
        // --------------------------------------

        const response =
          await API.post(
            "/conversations",
            {
              providerId,
            }
          );


        if (
          response.data?.success &&
          response.data?.conversation?._id
        ) {

          const conversationId =
            response.data.conversation._id;


          // ------------------------------------
          // Open Messages Page
          // ------------------------------------

          navigate(
            `/messages?conversation=${conversationId}`
          );

          return;
        }


        setChatError(
          response.data?.message ||
          "Unable to start conversation."
        );


      } catch (error) {

        console.error(
          "Start Conversation Error:",
          error
        );


        setChatError(
          error.response?.data?.message ||
          "Unable to start conversation. Please try again."
        );


      } finally {

        setChatLoading(false);

      }

    };


  // ==========================================
  // Call Provider
  // ==========================================

  const handleCall =
    () => {

      const phone =
        provider.phone ||
        provider.contact?.phone ||
        provider.contactNumber ||
        provider.userId?.phone;


      if (!phone) {

        console.log(
          "Provider phone number unavailable"
        );

        return;
      }


      window.location.href =
        `tel:${phone}`;

    };


  // ==========================================
  // JSX
  // ==========================================

  return (

    <div className="provider-banner">


      {/* ======================================
          Banner Image
      ====================================== */}

      <div className="provider-banner-image">

        <img
  src={bannerImage}
  alt={
    provider.business?.name ||
    provider.business?.businessName ||
    "Provider"
  }
  onError={(e) => {
    e.currentTarget.src = "/images/default-business.jpg";
  }}
/>
      </div>


      {/* ======================================
          Overlay
      ====================================== */}

      <div className="provider-banner-overlay">


        {/* ====================================
            Provider Logo
        ==================================== */}

        <div className="provider-logo">

         <img
  src={logoImage}
  alt={
    provider.business?.name ||
    provider.business?.businessName ||
    "Provider"
  }
  onError={(e) => {
    e.currentTarget.src = "/images/default-logo.png";
  }}
/>

        </div>


        {/* ====================================
            Provider Information
        ==================================== */}

        <div className="provider-banner-info">

          <h1>

            {
              provider.business?.name ||
              provider.business?.businessName ||
              "HomeFoods Provider"
            }

          </h1>


          <p>
            {provider.providerType}
          </p>


          <div className="provider-rating-row">

            <span className="rating">

              ⭐{" "}

              {provider.ratings?.averageRating ||
                provider.averageRating ||
                0}

            </span>


            <span>

              (
              {provider.ratings?.totalReviews ||
                0}{" "}
              Reviews)

            </span>

          </div>

        </div>


        {/* ====================================
            Actions
        ==================================== */}

        <div className="provider-banner-actions">


          {/* ==================================
              CHAT & BOOK
              Home Chef / Bakery / Catering /
              Provision
          ================================== */}

          {canChatAndBook && (

            <button
              type="button"
              className="provider-chat-button"
              onClick={handleChatAndBook}
              disabled={chatLoading}
            >

              <FaComments />

              <span>

                {chatLoading
                  ? "Opening Chat..."
                  : "Chat & Book an Order"}

              </span>

            </button>

          )}


          {/* ==================================
              COMING SOON
              Restaurant / Hotel
          ================================== */}

          {isChatComingSoon && (

            <button
              type="button"
              className="provider-chat-button provider-coming-soon-button"
              disabled
            >

              <FaComments />

              <span>
                Chat & Order — Coming Soon
              </span>

            </button>

          )}


          {/* ==================================
              CALL NOW
          ================================== */}

          <button
            type="button"
            className="provider-call-button"
            onClick={handleCall}
          >

            <FaPhone />

            <span>
              Call Now
            </span>

          </button>


          {/* ==================================
              SECURITY
          ================================== */}

          <div className="provider-banner-trust">

            <FaShieldAlt />

            <span>
              Quick response • Safe & Secure
            </span>

          </div>


          {/* ==================================
              Error
          ================================== */}

          {chatError && (

            <div className="provider-chat-error">

              {chatError}

            </div>

          )}

        </div>

      </div>

    </div>

  );

}